// extracted by mini-css-extract-plugin
export default {"sortBtn":"ParamsSort_sortBtn__+2YBc","sortIcon":"ParamsSort_sortIcon__prSkm","rotation":"ParamsSort_rotation__WGdAW"};